<template>
  <div class="advanced-search">
    <div class="row">
      <div class="column-main-left">
        <div class="content-container">
          <div class="header">
            <div class="title">Advanced Search</div>
          </div>
          <div class="content">
            <div class="nav-search-container">
              <input type="text" placeholder="Search topic title" v-model="searchText" id="search-text-input" @keyup.enter="search"/>
              <div id="search-icon-container"><img src="icons/icon-search-3.png" alt=""/></div>		    
            </div>
            <div class="search-button">
              <button @click="searchButton">Search</button>
            </div>
          </div>
        </div>
      </div>
      <div class="column-sidebar-right">
        <div class="content-container" v-if="formatedBoards != null && formatedBoards.length > 0">
          <div class="header">
            <div class="title">Boards filter</div>
          </div>
          <div class="content boards-container">
            <multiselect class="multi-select-control" :limit="3" v-model="selectedBoards" placeholder="Select boards" label="name" track-by="id" :options="formatedBoards" :multiple="true" :taggable="false"></multiselect>
          </div>
        </div>
        <div class="content-container">
          <div class="header">
            <div class="title">Date filter</div>
          </div>
          <div class="content">
            <div class="data-container">
            <vc-date-picker
              mode='range'
              v-model='range'
              class="range-picker"
              style="width:250px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '../../api/api';
import moment from 'moment';
import common from '../../modules/common'

export default {
  components: {Multiselect},
  data() {
    return {
      searchText: null,
      categories: [],
      selectedBoards: [],
      range: null,
    }
  },
  mounted() {
    
    var bc = common.breadcrumb.create([
        { url: '/', text: 'UtterAccess' },
        { url: '/search', text: 'Search' }
    ]);
    this.$store.dispatch("breadcrumb", bc);

    api.get('/boards')
      .then(response => {
        this.categories = response.data.categories;
      }
    );
  },
  computed: {
    formatedBoards() {
      let boards = [];
      for(let i = 0;i < this.categories.length; i++){
        const currentCategorie = this.categories[i];
        boards = boards.concat(currentCategorie.boards);
      }
      return boards;
    },
  },
  methods: {
    search() {
      this.$store.dispatch('search', this.searchText).then(() => {
        this.$router.push('/topics/list/search');
      });
    },
    searchButton() {
      let params = {};
      if(this.selectedBoards != null && this.selectedBoards.length > 0){
        params.boardsIds = this.selectedBoards.map(r=>r.id);
      }
      if(this.range != null) {
        if(this.range.start != null) {
          let start = moment(this.range.start);
          params.start = start.utc();
        }
        if(this.range.end != null) {
          let end = moment(this.range.end);
          params.end = end.utc();
        }
      }
      params.text = this.searchText;
      this.$store.dispatch('advancedSearch', params).then(() => {
        this.$router.push('/topics/list/search');
      });
    }
  }
}
</script>

<style src='vue-multiselect/dist/vue-multiselect.min.css'></style>

<style scoped>
#search-text-input{
  max-width: 400px;
  width:400px;
  position: relative;
  top: 2px;
}
.boards-container{
  position: relative;
  height: 70px;
}
.multi-select-control{
  position: absolute;
  z-index: 2000;
  width: 90%;
}
.search-button{
  float:right;
}

.search-button button{
  font-size: 20px;
  margin-top:10px;
}
.range-picker{
  width: 90%;
}
.data-container{
  width: 94%;
}
</style>